/** Small, deterministic browser models of verified app rules. Synthetic data only. */
export type EntryKind = "transfer" | "expense";
export function ledgerPreview(dollars: number, kind: EntryKind) {
  const amount = Math.round(Math.min(500, Math.max(0, dollars)) * 100);
  const checking = 240000 - amount;
  const savings = 120000 + (kind === "transfer" ? amount : 0);
  return {
    checking: checking / 100,
    savings: savings / 100,
    total: (checking + savings) / 100,
    spending: kind === "expense" ? amount / 100 : 0,
  };
}
export function portionPreview(grams: number) {
  const ratio = Math.min(300, Math.max(25, grams)) / 100;
  return {
    ratio,
    calories: 198 * ratio,
    protein: 12 * ratio,
    carbs: 24 * ratio,
    fat: 6 * ratio,
  };
}
export interface DemoSet {
  weight: number;
  reps: number;
}
export function sessionVolume(sets: DemoSet[]) {
  return sets.reduce((total, set) => total + set.weight * set.reps, 0);
}
export const money = (value: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
export const decimal = (value: number) => Number(value.toFixed(1)).toString();
